import type React from 'react';
import { isFunction } from './utils.js';

type AnyRef<T extends HTMLElement> =
  | React.MutableRefObject<T | null>
  | ((_ref: T | null) => void)
  | React.Dispatch<React.SetStateAction<T | null>>
  | false
  | undefined
  | null;

export const setRef = <T extends HTMLElement>(ref: AnyRef<T>, value: T) => {
  if (isFunction(ref)) {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};

export const mergeRefs = <T extends HTMLElement>(...refs: AnyRef<T>[]) => {
  const mergeRefsFunc = (node: T | null) => {
    if (!node) return;
    refs.forEach((ref) => setRef(ref, node));
  };
  return mergeRefsFunc;
};

export function setMultipleRefs<T = unknown>(
  refs: Array<React.RefObject<T> | React.LegacyRef<T>>,
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}

export function logger(...args: unknown[]) {
  // eslint-disable-next-line no-console
  console.log(...args);
}
